import { React, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/LandingPage.css";
import Carousel from "./Carousel";
import { FaArrowRight, FaHospital, FaAmbulance, FaHome } from "react-icons/fa";
import RecentEvents from "../components/RecentEvents";
import ProductTabs from "../components/ProductTabs";
//import ProductSpinner from "../components/ProductSpinner"; unused componets that can be added later
//import TestimonialsSection from "./testimonials-section";

const LandingPage = () => {

    useEffect(() => {
        const fadeInElements = document.querySelectorAll('.fade-in');

        const fadeInObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, {
            threshold: 0.15, // Trigger when 15% of the element is visible
            rootMargin: '0px 0px -50px 0px' // Slightly before element comes into view
        });

        fadeInElements.forEach(element => {
            fadeInObserver.observe(element);
        });

        // Cleanup observer on component unmount
        return () => {
            fadeInElements.forEach(element => {
                fadeInObserver.unobserve(element);
            });
        };
    }, []);


    return (
        <div className="landing-page">
            {/* Hero Section */}
            <section className="hero fade-in">
                <div className="hero-corner-container">
                    <div className="hero-corner-bl"></div>
                    <div className="hero-corner-tr"></div>
                    <div className="hero-corner-tl"></div>
                    <div className="hero-corner-br"></div>
                </div>
                <div className="hero-content">
                    <h1 className="hero-header">The Best Solutions Flow Through Us</h1>
                    {/* Subtitle Section */}
                    <div className="hero-description">
                        <p>43 years of manufacturing medical gas delivery devices.</p>
                    </div>

                    {/* New Section with Image and Text */}
                    <div className="rohs-container">
                        <img src="TESTDEMO/mdsap.png" alt="Flotec Manufacturing" className="hero-image-rohs" />
                        <p className="rohs-text">
                            Accredited Medical Device Manufacturer for the governing bodies of the United States, Canada, Austraila and Japan.
                        </p>
                    </div>

                    <div className="hero-buttons">
                        <Link to="/products" className="hero-button primary">
                            View Product Catalog
                            <FaArrowRight style={{ marginLeft: '4px' }} />
                        </Link>
                        <Link to="/about" className="hero-button secondary">
                            About Flotec
                            <FaArrowRight style={{ marginLeft: '4px' }} />
                        </Link>
                    </div>
                </div>
                <div className="hero-image">
                    <Carousel />
                </div>
            </section>
            <div className="green-bar fade-in"></div>

            <div className="blender-image fade-in">
                <ProductTabs />
            </div>
            <div className="green-bar fade-in"></div>


            {/* Features Section */}
            <section className="features fade-in">
                <h2>Why Shop With Us?</h2>
                <div className="features-list">
                    <div className="feature fade-in">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="100px" width="100px" version="1.1" viewBox="0 0 512.001 512.001">
                            <g>
                                <g>
                                    <g>
                                        <path d="M331.881,138.479l-41.577-6.042l-18.593-37.675c-6.413-12.995-25.004-13.003-31.421,0l-18.593,37.675l-41.577,6.042c-14.34,2.084-20.093,19.761-9.709,29.882l30.086,29.325l-7.102,41.409c-2.449,14.282,12.585,25.216,25.42,18.469l37.188-19.551l37.188,19.551c12.782,6.724,27.879-4.118,25.418-18.469l-7.102-41.409l30.086-29.325C351.967,158.247,346.23,140.564,331.881,138.479z M278.072,210.032c-23.589-12.401-19.839-12.776-44.144,0c4.503-26.246,6.033-22.806-13.641-41.984c27.141-3.944,23.919-2.049,35.713-25.946c11.815,23.94,8.578,22.003,35.713,25.946C272.595,186.684,273.437,183.006,278.072,210.032z" />
                                        <path d="M509.618,404.762l-105.84-183.328C437.21,121,362.258,16.569,256,16.569c-106.281,0-181.197,104.464-147.778,204.863L2.382,404.762c-7.441,12.888,3.632,28.647,18.289,26l68.417-12.37l23.488,65.441c5.021,13.986,24.184,15.794,31.661,2.842l92.32-159.904c12.954,1.605,25.922,1.605,38.884,0l92.32,159.904c7.476,12.95,26.64,11.149,31.661-2.842l23.488-65.441l68.417,12.37C505.976,433.407,517.065,417.66,509.618,404.762z M132.79,436.426l-15.732-43.831c-2.89-8.051-11.174-12.845-19.607-11.321l-45.833,8.287l75.192-130.243c17.889,26.661,43.956,47.345,74.314,58.75L132.79,436.426z M143.757,216.688C112.446,137.602,170.649,51.607,256,51.607c85.417,0,143.537,86.038,112.244,165.08C327.705,319.048,183.623,317.357,143.757,216.688z M414.549,381.273c-8.422-1.521-16.715,3.264-19.607,11.321l-15.732,43.831l-68.335-118.36c29.649-11.209,55.037-30.548,74.314-58.75l75.192,130.243L414.549,381.273z" />
                                    </g>
                                </g>
                            </g>
                        </svg>

                        <h3>High Quality</h3>
                        <p>Only the best products built to last.</p>
                    </div>
                    <div className="feature fade-in">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000000"
                            width="100px"
                            height="100px"
                            viewBox="0 0 444.456 444.456"
                        >
                            <g>
                                <path d="M398.754,160.028l-61.244-5.833V26.894c0-9.159-4.591-17.597-12.282-22.571c-7.689-4.974-17.269-5.702-25.622-1.945L25.795,125.495c-0.713,0.321-1.38,0.754-1.97,1.291c-1.563,1.421-2.455,3.436-2.455,5.549V402.06c0,3.867,2.939,7.1,6.789,7.466l365.497,34.809c0.846,0.081,1.691,0.12,2.535,0.12c6.654,0,13.136-2.48,18.098-6.992c5.59-5.083,8.796-12.332,8.796-19.888v-230.79C423.086,172.853,412.625,161.349,398.754,160.028z M217.525,142.768L322.51,95.564v57.203L217.525,142.768z M298.679,89.833l-111.338,50.061l-57.767-5.502l160.784-72.291c2.642-1.191,4.813-0.102,5.624,0.422c0.811,0.524,2.698,2.057,2.698,4.958V89.833z M305.758,16.059c3.746-1.685,7.875-1.371,11.324,0.86c3.45,2.231,5.428,5.867,5.428,9.976v52.223l-8.831,3.971V67.482c0-7.126-3.572-13.69-9.556-17.557c-5.982-3.866-13.432-4.426-19.922-1.502L99.389,131.517l-41.6-3.962L305.758,16.059z M408.086,417.577c0,3.388-1.381,6.51-3.888,8.79c-2.507,2.28-5.747,3.36-9.119,3.037L36.371,395.241V140.583l360.961,34.377c6.131,0.584,10.754,5.668,10.754,11.827V417.577z" />
                                <path d="M362.523,271.072c-14.896,0-27.014,13.083-27.014,29.165c0,16.081,12.119,29.165,27.014,29.165s27.014-13.083,27.014-29.165C389.537,284.155,377.419,271.072,362.523,271.072z M362.523,314.401c-6.625,0-12.014-6.354-12.014-14.165c0-7.811,5.39-14.165,12.014-14.165s12.014,6.354,12.014,14.165C374.537,308.047,369.148,314.401,362.523,314.401z" />
                            </g>
                        </svg>

                        <h3>Affordable Prices</h3>
                        <p>Cost-effective options avalible for purchase.</p>
                    </div>
                    <div className="feature fade-in">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#000000"
                            version="1.1"
                            width="100px"
                            height="100px"
                            viewBox="0 0 612 612"
                        >
                            <g>
                                <path d="M612,327.56v-21.606c0-10.533-4.213-20.628-11.701-28.037L484.107,162.958c-7.384-7.306-17.352-11.403-27.739-11.403h-58.622v-21.988c0-16.336-13.243-29.58-29.58-29.58H29.58C13.243,99.987,0,113.23,0,129.567V327.56H612zM432.551,190.303c0-2.563,2.071-4.634,4.635-4.634h21.396c1.184,0,2.366,0.494,3.253,1.282l91.006,86.865c3.057,2.86,0.986,7.987-3.154,7.987h-112.5c-2.563,0-4.635-2.07-4.635-4.634V190.303zM612,343.903v65.486c0,16.336-13.243,29.578-29.579,29.578h-31.65c-5.719-39.242-39.539-69.412-80.357-69.412c-40.721,0-74.54,30.17-80.259,69.412h-160.42c-5.718-39.242-39.538-69.412-80.259-69.412c-40.721,0-74.541,30.17-80.259,69.412H29.58C13.243,438.968,0,425.726,0,409.39v-65.486H612zM470.456,389.313c-33.883,0-61.351,27.467-61.351,61.35s27.469,61.35,61.351,61.35s61.35-27.467,61.35-61.35S504.339,389.313,470.456,389.313zM470.456,481.339c-16.941,0-30.675-13.734-30.675-30.676s13.732-30.674,30.675-30.674c16.941,0,30.676,13.732,30.676,30.674S487.397,481.339,470.456,481.339zM149.464,389.313c-33.883,0-61.35,27.467-61.35,61.35s27.468,61.35,61.35,61.35s61.35-27.467,61.35-61.35S183.346,389.313,149.464,389.313zM149.464,481.339c-16.941,0-30.676-13.734-30.676-30.676s13.734-30.674,30.676-30.674c16.941,0,30.675,13.732,30.675,30.674S166.405,481.339,149.464,481.339z" />
                            </g>
                        </svg>
                        <h3>Fast Delivery</h3>
                        <p>Quick and reliable shipping to your establishment.</p>
                    </div>
                </div>
            </section>
            <div className="green-bar fade-in"></div>


            <RecentEvents />

            <div className="green-bar fade-in"></div>





            {/* Markets We Serve Section - Replacing Testimonials */}
            <section className="markets-we-serve fade-in">
                <h2 className="timeline-title">Markets We Serve</h2>
                <div className="markets-grid">
                    <div className="market-card fade-in">
                        <div className="market-icon">
                            <FaHospital size={50} />
                        </div>
                        <h3>Healthcare</h3>
                        <p>Providing reliable oxygen delivery solutions for hospitals, clinics, and medical facilities.</p>
                    </div>

                    <div className="market-card fade-in">
                        <div className="market-icon">
                            <FaAmbulance size={50} />
                        </div>
                        <h3>Emergency Services</h3>
                        <p>Equipping first responders with reliable oxygen delivery systems for emergency situations.</p>
                    </div>

                    <div className="market-card fade-in">
                        <div className="market-icon">
                            <FaHome size={50} />
                        </div>
                        <h3>OEM</h3>
                        <p>Supporting partners with OEM Products and custom solutions tailored to business needs</p>
                    </div>
                </div>
            </section>
            {/* Call-to-Action Section */}
            <div className="green-bar fade-in"></div>

            <div className="cta-row">
                <section className="cta">
                    <h2>View our products</h2>
                    <Link to="/products" className="cta-button">
                        Product Catalog
                    </Link>
                </section>

                <section className="cta">
                    <h2>Instructions for Use Finder</h2>
                    <Link to="/ifu" className="cta-button">
                        Find IFUs
                    </Link>
                </section>
            </div>


            {/*
            <section>
                <TestimonialsSection/>
            </section>
            */}


            {/* New Section with Thick Green Bar */}
            {/*
            <div className="green-bar fade-in"></div>
            <section className="new-section fade-in">
                <h2 className="blender-title">Accurate Oxygen delivery solutions for Patient Care</h2>
                <h2 className="blender-subtitle">Flowmeters, Oxygen Analyzers, Mix Mastrr Blender</h2>

                <div className="blender-image fade-in">
                    <ProductSpinner />
                </div>
            </section>
            */}


        </div>
    );
};

export default LandingPage;

